export default function Services() {
  const services = {
    hairMake: [
      { name: 'Entertainment Makeup', description: 'Professional makeup for TV, film, and stage', icon: 'ri-movie-line' },
      { name: 'Fashion Makeup', description: 'Trendy makeup for photoshoots, shows, and events', icon: 'ri-camera-line' },
      { name: 'Artist Makeup', description: 'Unique makeup for musicians and performers', icon: 'ri-star-line' },
      { name: 'Daily Makeup', description: 'Natural and beautiful everyday makeup', icon: 'ri-heart-line' },
      { name: 'Bridal Makeup', description: 'Glamorous makeup for your special day', icon: 'ri-gift-line' },
      { name: 'Makeup Lessons', description: 'Individual lessons to learn professional techniques', icon: 'ri-book-open-line' }
    ],
    music: [
      { name: 'Original Composition', description: 'Composition and arrangement of original music', icon: 'ri-music-2-line' },
      { name: 'Track Making', description: 'Beat and instrumental production', icon: 'ri-equalizer-line' },
      { name: 'BGM Production', description: 'Background music for video, games, and stores', icon: 'ri-volume-up-line' },
      { name: 'Artist Support', description: 'Recording, mixing, and mastering services', icon: 'ri-mic-line' },
      { name: 'Sound Design', description: 'Creation of sound effects and ambient sounds', icon: 'ri-sound-module-line' },
      { name: 'Music Consulting', description: 'Comprehensive advice on music production', icon: 'ri-lightbulb-line' }
    ]
  };

  return (
    <section id="services" className="py-24 px-6 bg-gradient-to-b from-slate-900 to-black">
      <div className="max-w-7xl mx-auto">
        <div className="text-center mb-16">
          <h2 className="text-4xl md:text-5xl font-bold mb-4 tracking-wider">SERVICES</h2>
          <div className="w-24 h-1 bg-purple-500 mx-auto"></div>
          <p className="mt-6 text-lg text-gray-300">Diverse creative services we provide</p>
        </div>

        <div className="grid lg:grid-cols-2 gap-12">
          <div>
            <div className="flex items-center mb-8">
              <div className="w-12 h-12 flex items-center justify-center bg-purple-600 rounded-lg mr-4">
                <i className="ri-magic-line text-2xl"></i>
              </div>
              <h3 className="text-3xl font-bold">Hair & Makeup Menu</h3>
            </div>
            
            <div className="space-y-4">
              {services.hairMake.map((service, index) => (
                <div
                  key={index}
                  className="group bg-slate-800/40 p-6 rounded-lg border border-purple-500/20 hover:border-purple-500/60 hover:bg-slate-800/60 transition-all duration-300 cursor-pointer"
                >
                  <div className="flex items-start">
                    <div className="w-10 h-10 flex items-center justify-center bg-purple-600/20 rounded-lg mr-4 group-hover:bg-purple-600/40 transition-colors">
                      <i className={`${service.icon} text-xl text-purple-400`}></i>
                    </div>
                    <div className="flex-1">
                      <h4 className="text-lg font-semibold mb-2 group-hover:text-purple-400 transition-colors">{service.name}</h4>
                      <p className="text-sm text-gray-400">{service.description}</p>
                    </div>
                  </div>
                </div>
              ))}
            </div>
          </div>

          <div>
            <div className="flex items-center mb-8">
              <div className="w-12 h-12 flex items-center justify-center bg-purple-600 rounded-lg mr-4">
                <i className="ri-music-2-line text-2xl"></i>
              </div>
              <h3 className="text-3xl font-bold">Music Production Menu</h3>
            </div>
            
            <div className="space-y-4">
              {services.music.map((service, index) => (
                <div
                  key={index}
                  className="group bg-slate-800/40 p-6 rounded-lg border border-purple-500/20 hover:border-purple-500/60 hover:bg-slate-800/60 transition-all duration-300 cursor-pointer"
                >
                  <div className="flex items-start">
                    <div className="w-10 h-10 flex items-center justify-center bg-purple-600/20 rounded-lg mr-4 group-hover:bg-purple-600/40 transition-colors">
                      <i className={`${service.icon} text-xl text-purple-400`}></i>
                    </div>
                    <div className="flex-1">
                      <h4 className="text-lg font-semibold mb-2 group-hover:text-purple-400 transition-colors">{service.name}</h4>
                      <p className="text-sm text-gray-400">{service.description}</p>
                    </div>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
